import { convertSVGToDataURL } from "./pdfImageUtils";

const EMBEDDED_PDF_LOGO_SVG = `<svg width="59" height="22" viewBox="0 0 59 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5907 0H23.9633V13.0435H20.5907V0ZM9.75483 4.83058H18.4247V7.7289H13.1235V13.0435H9.75284L9.75483 4.83058ZM19.386 2.89838H9.75483V0H19.386V2.89838ZM47.4798 6.36075C47.8742 6.06915 48.1958 5.68979 48.4194 5.25249C48.6429 4.8152 48.7623 4.33187 48.7682 3.84048C48.7682 1.44022 47.1986 0.00806208 44.5798 0.00806208H33.9195L31.4464 8.27296H31.4085L28.9354 0H25.1659V2.89838H26.3725L29.7472 13.0435H33.1098L36.4844 2.89838H44.2049C45.242 2.89838 45.4016 3.58045 45.4016 3.98449C45.4016 4.38854 45.248 5.07261 44.2049 5.07261H38.421V7.97092H44.3605C45.3976 7.97092 45.5571 8.651 45.5571 9.05704C45.5571 9.46309 45.4016 10.1452 44.3605 10.1452H38.411V13.0435H44.8351C47.3302 13.0435 48.9417 11.5113 48.9417 9.13905C48.9417 7.44287 48.0422 6.72079 47.4758 6.35275M29.2605 15.9418C18.7757 15.9418 8.85135 17.692 0 20.8143V21.0303C9.58578 18.7442 19.4075 17.6029 29.2605 17.63C39.1136 17.6027 48.9353 18.7441 58.521 21.0303V20.8143C49.6717 17.692 39.7453 15.9418 29.2605 15.9418ZM49.1112 13.0395V11.9734H48.7582V11.8313H49.5999V11.9734H49.2488V13.0395H49.1112ZM49.7395 13.0395V11.8393H49.9509L50.2102 12.6954C50.2281 12.7754 50.2461 12.8355 50.258 12.8715C50.272 12.8294 50.2899 12.7674 50.3159 12.6714L50.5751 11.8333H50.7626V13.0335H50.619V12.0334L50.3039 13.0335H50.1783L49.8711 12.0054V13.0335L49.7395 13.0395Z" fill="#2732D4"/></svg>`;

export function resolveBundledAssetUrl(assetUrl) {
  if (!assetUrl || typeof assetUrl !== "string") {
    return assetUrl;
  }

  if (/^(https?:|data:|blob:)/i.test(assetUrl)) {
    return assetUrl;
  }

  let path = assetUrl.replace(/^\.\//, "");
  if (!path.startsWith("/")) {
    path = `/${path}`;
  }

  let publicPrefix = process.env.PUBLIC_URL || "";
  if (publicPrefix === ".") {
    publicPrefix = "";
  }
  publicPrefix = publicPrefix.replace(/\/$/, "");

  const combinedPath = `${publicPrefix}${path}`.replace(/\/{2,}/g, "/");

  if (typeof window !== "undefined") {
    try {
      return new URL(combinedPath, window.location.origin).href;
    } catch (error) {
      console.warn("Unable to resolve bundled asset URL:", combinedPath, error);
    }
  }

  return combinedPath;
}

async function fetchSvgText(assetUrl) {
  const resolvedUrl = resolveBundledAssetUrl(assetUrl);
  const response = await fetch(resolvedUrl);

  if (!response.ok) {
    throw new Error(`Logo fetch failed with status ${response.status}`);
  }

  return response.text();
}

async function convertEmbeddedLogo() {
  return convertSVGToDataURL(EMBEDDED_PDF_LOGO_SVG, 184, 66);
}

export async function loadPdfLogoDataUrl(svgLogoPath) {
  if (!svgLogoPath) {
    return null;
  }

  if (/^data:image\//i.test(svgLogoPath)) {
    return svgLogoPath;
  }

  try {
    const svgText = await fetchSvgText(svgLogoPath);
    return await convertSVGToDataURL(svgText, 184, 66);
  } catch (fetchError) {
    console.warn(
      "PDF logo could not be loaded from bundled path; trying embedded fallback.",
      fetchError
    );
  }

  try {
    return await convertEmbeddedLogo();
  } catch (embeddedError) {
    console.warn(
      "PDF logo could not be loaded; continuing without logo.",
      embeddedError
    );
    return null;
  }
}
